import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { HOW_THIS_WORKS_SECTIONS } from './constants';

const HowThisWorksModal = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
    <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>How Company Profile works</DialogTitle>
    <DialogContent>
      <Box display='flex' flexDirection='column' gap={2.5} pt={0.5}>
        {HOW_THIS_WORKS_SECTIONS.map((section) => (
          <Box key={section.title}>
            <Typography variant='subtitle1' fontWeight={700} mb={0.5}>
              {section.title}
            </Typography>
            <Typography variant='body2' color='text.secondary' sx={{ lineHeight: 1.6 }}>
              {section.body}
            </Typography>
          </Box>
        ))}
      </Box>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2.5 }}>
      <Button variant='contained' onClick={onClose} sx={{ textTransform: 'none', fontWeight: 600 }}>
        Got it
      </Button>
    </DialogActions>
  </Dialog>
);

export default HowThisWorksModal;
